import DefaultError from './DefaultError'

export default DefaultError
